<template>
    <div class="question-edit-wrapper">
        <FullHeightBaseBox
            class="question-edit-box"
            :class="{ 'question-edit-tranform': compeleted }"
            :isShowBack="true"
            :title="boxTitle"
            @close="close"
        >
            <div class="question-edit-content">
                <LanguageMenu class="question-edit-langmenu"></LanguageMenu>
                <div class="question-edit-question">
                    <div class="edit-center">
                        <LeftQuestionForm
                            class="left-panel"
                            :default="clusterQuestion"
                            :curPanel="curPanel"
                            @switchAnswer="switchAnswer"
                            @similarEdit="switchSimilar"
                        />
                        <component
                            :is="showingPanel"
                            class="right-panel"
                            :currentTab="currentTab"
                            :hasRecommendSimilar="hasRecommendSimilar"
                            :questionId="data.questionId"
                            :sceneId="data.sceneId"
                        />
                    </div>
                    <BottomBar ref="bottomBar" class="edit-bottom" @close="close" @saveClick="saveHandle" />
                </div>
            </div>
        </FullHeightBaseBox>
    </div>
</template>

<script>
import FullHeightBaseBox from "@/views/zhiji/bComponents/FullHeightBaseBox";
import BottomBar from "./BottomBar";
import LeftQuestionForm from "./LeftQuestionForm";
import Default from "./Default";
import AnswerPanel from "./answers/AnswerPanel";
import SimilarPanel from "./similars/SimilarPanel";
import LanguageMenu from "./LanguageMenu";
import i18n from "@/i18n";

export default {
    name: "QuestionEditModal",
    props: ["data"], // {curPanel, questionId, sceneId, closeHandler, currentTab, hasRecommendSimilar}
    components: {
        FullHeightBaseBox,
        BottomBar,
        LeftQuestionForm,
        Default,
        AnswerPanel,
        SimilarPanel,
        LanguageMenu
    },
    data() {
        return {
            curPanel: this.data.curPanel || "Default",
            compeleted: false,
            currentTab: this.data.currentTab ? this.data.currentTab : "ExistingSimilars",
            hasRecommendSimilar: this.data.hasRecommendSimilar ? this.data.hasRecommendSimilar : false,
        };
    },
    computed: {
        showingPanel() {
            const curAnswer = this.$store.state.zhiji.questionEdit.currentAnswer;

            // 删除正在编辑的答案时
            if (!curAnswer && this.curPanel === "AnswerPanel") {
                return "Default";
            }

            if (this.curPanel !== "AnswerPanel") {
                this.$store.commit("zhiji/editQsSelectAnswer", null);
            }

            return this.curPanel;
        },
        clusterQuestion() {
            return this.data.standQuestion || "";
        },
        boxTitle() {
            return this.$t("zhiji.knowlege.quesEditModal.quesEdit");
        }
    },
    mounted() {
        this.$store.dispatch("zhiji/initQuesEditor", {
            questionId: this.data.questionId,
            sceneId: this.data.sceneId,
            clusterId: this.data.clusterId,
            clusterQuestionId: this.data.clusterQuestionId,
            conventionQuestionId: this.data.conventionQuestionId,
            clusterLang: this.data.clusterLang
        });

        // 获取答案属性： 基础属性，用户画像ID
        this.getAnswerProps();

        setTimeout(() => {
            this.compeleted = true;
        }, 10);
        window.addEventListener("beforeunload", this.closePageHandel);
    },
    destroyed() {
        window.removeEventListener("beforeunload", this.closePageHandel);
    },
    methods: {
        getAnswerProps() {
            this.$store.dispatch("zhiji/queryAnswerProps");
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        cancelSave() {
            this.$store.commit("zhiji/editQsClearModule");
            this.compeleted = false;
            this.data.closeHandler && this.data.closeHandler.call(null);
            setTimeout(() => {
                this.$emit("closeModal");
            }, 500);
        },
        questionAlterTip(text) {
            this.$confirm(text, this.$t("zhiji.common.tips"), { closeOnClickModal: false, modalAppendToBody: true}).then(() => {
                    this.$refs.bottomBar.onlineClick();
                }).catch(() => {
                    this.cancelSave();
                });
        },
        judgeContent() {
            const { answers } = this.$store.state.zhiji.questionEdit;
            const hasDelete = answers.some(item => item.updateState === "delete");
            const changeList = [];
            answers.forEach(item => {
                if (item.updateState) {
                    changeList.push(item.name);
                }
            });
            const flag = hasDelete || changeList.length === 0;
            return { changeList, flag };
        },
        close() {
            const { hasChange, similarIsEdit } = this.$store.state.zhiji.questionEdit;
            let tips = "";
            if (similarIsEdit) {
                // 相似问的文本域有值
                tips = i18n.t("zhiji.knowlege.quesEditModal.hasEditSimilarWarnTip");
                this.questionAlterTip(tips);
            } else if (hasChange) {
                const { changeList, flag } = this.judgeContent();
                tips = flag
                    ? `${i18n.t("zhiji.knowlege.quesEditModal.hasModifiedAnsNumber")}`
                    : `${changeList.join()}:${i18n.t("zhiji.knowlege.quesEditModal.hasModifiedAnswerContent")}`;
                this.questionAlterTip(tips);
            } else {
                this.cancelSave();
            }
        },
        switchAnswer() {
            this.curPanel = "AnswerPanel";
        },
        switchSimilar() {
            let getQuestionId = this.getStorePorp("questionInfo").questionId;
            getQuestionId ? (this.curPanel = "SimilarPanel") : this.showWarningModal();
        },
        showWarningModal() {
            this.$message({
                message: i18n.t("zhiji.knowlege.quesEditModal.editSimilarWarnTip"),
                center: true,
                duration: 2000,
                type: "warning"
            });
        },
        saveHandle() {
            if (this.data.saveHandler) {
                this.data.saveHandler.call(null);
            }
        },
        closePageHandel(e) {
            const { hasChange, similarIsEdit } = this.$store.state.zhiji.questionEdit;
            if (similarIsEdit || hasChange) {
                const confirmationMessage = i18n.t("zhiji.knowlege.quesEditModal.hasEditSimilarWarnTip");
                e.returnValue = confirmationMessage;
                return confirmationMessage;
            }
            return null;
        }
    }
};
</script>

<style lang="less" scoped>
.question-edit-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.6);
    overflow: hidden;

    .question-edit-box {
        transition: transform 0.5s;
        transform: translateX(100%);
        width: 100%;
        background: #f2f7fb;
    }

    .question-edit-tranform {
        transform: translateX(0);
    }

    .question-edit-content {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;
    }

    .question-edit-langmenu {
        width: 180px;
        height: 100%;
    }

    .question-edit-question {
        width: calc(100% - 180px);
        height: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
    }

    .edit-center {
        flex: 1;
        display: flex;
        height: 100%;
        min-height: 100px;
        .right-panel {
            flex: 1;
            min-width: 680px;
        }
    }

    .question-edit-modal {
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
</style>
